import React from 'react';
import T from 'prop-types';

import {
  BulletContainer,
  DisclaimersListContainer,
  StyledListItem,
  StyledP2,
} from './styledComponents';

const DisclaimersList = ({ disclaimers }) => (
  <DisclaimersListContainer role="list">
    {disclaimers.map((disclaimer) => (
      <StyledListItem key={disclaimer} role="listitem">
        <BulletContainer>
          <StyledP2>{'\u2022'}</StyledP2>
        </BulletContainer>
        <StyledP2>{disclaimer}</StyledP2>
      </StyledListItem>
    ))}
  </DisclaimersListContainer>
);

export default DisclaimersList;

DisclaimersList.propTypes = { disclaimers: T.arrayOf(T.string).isRequired };
